import React from "react";
import { AppBar, Tab, Tabs } from "@material-ui/core";
import { useLocation } from "react-router-dom";
import history from "@history";
import { useTranslation } from "react-i18next";

type TabRoute = { label: string; path: string };

const CouponsTabs: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const tabs: TabRoute[] = [
    { label: t("app.main.coupons.tabs.promotional", "Promotional coupons"), path: "/coupons/promotional" },
    { label: t("app.main.coupons.tabs.reservations", "Reservations with coupon"), path: "/coupons/reservations" },
  ];

  const activeIndex = Math.max(0, tabs.findIndex((x) => location.pathname.startsWith(x.path)));

  return (
    <AppBar position="static" color="default" elevation={0}>
      <Tabs
        value={activeIndex}
        onChange={(_e, idx) => history.push(tabs[idx].path)}
        indicatorColor="primary"
        textColor="primary"
      >
        {tabs.map((tab) => (
          <Tab key={tab.path} label={tab.label} />
        ))}
      </Tabs>
    </AppBar>
  );
};

export default CouponsTabs;
